import { createIcon } from '@integration-frontends/common/ui/icons/create-icon';
import React from 'react';
import './icon-download.scss';

export const IconDownload = createIcon(<div className="icon-download" />);
